:host {
    --uui-logo-width: 100%;
}

svg {
    width: var(--uui-logo-width);
}